<template>
    <el-tabs v-model="activeName" class="precise-push-wrap">
        <el-tab-pane :label="$i18n.t('zhiji.portrait.param')" name="PortraitParams">
            <PortraitParams />
        </el-tab-pane>
        <el-tab-pane :label="$i18n.t('zhiji.portrait.tag')" name="portraitTags">
            <portraitTags />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import PortraitParams from "./components/portraitParams/Index.vue";
import portraitTags from "./components/portraitTags/Index.vue";

export default {
    name: "PrecisePushPage",
    components: {
        PortraitParams,
        portraitTags
    },
    data() {
        return {
            activeName: "PortraitParams"
        };
    }
};
</script>

<style lang="scss" scoped>
.precise-push-wrap {
    background: #f2f7fb;
    height: 100%;
    box-sizing: border-box;
    /deep/.el-tabs__content {
        height: calc(100% - 46px);
    }
    /deep/.el-tab-pane {
        height: 100%;
    }

    /deep/.el-tabs__nav {
        margin-left: 18px;
    }

    /deep/.el-tabs__nav-wrap{
        margin: 0;
        height: 48px;
        background: #fbfcfd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 0;
    }

    /deep/.el-tabs__item{
        height: 48px;
        line-height: 48px;
    }

}
</style>
